import classNames from "classnames";
import styled from "styled-components";
const CustomToolbar = styled.div`
display: flex;
align-items: center;
flex-wrap: wrap;
justify-content: space-between;
padding: 10px 10px 0px 10px;
`;
interface CustomToolBarProps {
  className?: string;
  children?: React.ReactNode;
}

const CustomToolBar: React.FC<CustomToolBarProps> = ({className, ...props}) => {

const toolbarClasses = classNames("common__custom_toolbar", className);
  return (
  <CustomToolbar className={toolbarClasses}>
    {props.children}
  </CustomToolbar>
  );
};

export default CustomToolBar;
